/**
 * @flow
 */

import { fromJS } from 'immutable';
import { SELECT_NAV_ITEM } from './actions';

const initialState = fromJS({
  item: null,
  index: null
});

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case SELECT_NAV_ITEM:
      return fromJS({
        item: action.item,
        index: action.index
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/nav/reducer.js